import { Plus, ShieldCheck } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";

/**
 * Empty state shown when the member hasn't added any policies yet. Extracted from
 * PoliciesPage.jsx during 08-Feb refactor for readability — no behavioural changes.
 */
export function PolicyEmptyState({ onAdd }) {
  return (
    <Card className="border-dashed border-border">
      <CardContent className="flex flex-col items-center gap-3 py-16 text-center">
        <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-gold/10 text-gold">
          <ShieldCheck className="h-5 w-5" />
        </div>
        <h3 className="font-serif text-xl text-text">No policies yet</h3>
        <p className="max-w-sm text-sm text-muted">
          Add your term life, health, motor and accident policies here to track sum assured,
          premiums and renewal dates in one place.
        </p>
        <Button onClick={onAdd} className="gap-2">
          <Plus className="h-4 w-4" /> Add your first policy
        </Button>
      </CardContent>
    </Card>
  );
}
